import { Yup } from "components/DynamicForm/utils";
import { ID_TYPES, DELIVERY_TYPES, SELECT_INPUT_TYPE, JSON_TABLE_INPUT_TYPE } from "utils/Constants";
import DynamicFormOptions from "utils/DynamicFormOptions";

const form = {
    sections: [
        {
            title: "Datos Personales",
            fields: [
                [
                    {
                        "type": "text",
                        "validation": Yup.string().required(),
                        "name": "name",
                        "label": "Nombre"
                    },
                    {
                        "type": "email",
                        "validation": Yup.string().email(),
                        "name": "email",
                        "label": "Email"
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "custom:tipo_identificacion",
                        "label": "Tipo Identificacion",
                        "options": ID_TYPES,
                        "sizing": {
                            "sm": 5
                        }
                    },
                    {
                        "type": "number",
                        "name": "custom:identificacion",
                        "label": "Identificacion",
                        "valueAsString": true
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "custom:e_invoice_active",
                        "label": "Enviar Factura Electronica para los paquetes",
                        "checkedValue": "1",
                        "unCheckedValue": "0"
                    },
                ]
            ]
        },
        {
            title: "Direccion y Contacto",
            fields: [
                [
                    {
                        "type": "tel",
                        "validation": Yup.string().required(),
                        "name": "custom:tel_home",
                        "label": "Telefono Casa"
                    },
                    {
                        "type": "tel",
                        "validation": Yup.string().required(),
                        "name": "custom:tel_mobile",
                        "label": "Telefono Celular"
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "custom:delivery_type",
                        "label": "Lugar de Entrega",
                        "optionsFunction": DynamicFormOptions.poBoxAddresses,
                        "sizing": {
                            "sm": 5
                        }
                    }
                ],
                [
                    {
                        "type": JSON_TABLE_INPUT_TYPE,
                        "name": "addresses",
                        "showDivisor": true,
                        "editable": false,
                        "legend": "Direcciones de Envio",
                        "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                        "dataSchema": {
                            "name": {
                                "label": "Nombre",
                                "type": "text",
                                "headingWidth": "col-3",
                            },
                            "address": {
                                "label": "Direccion",
                                "type": "text",
                                "headingWidth": "col-7",
                            }
                        },
                    },
                ]
            ]
        },
        {
            title: "Notificaciones",
            fields: [
                [
                    {
                        "type": "checkbox",
                        "name": "custom:email_notification",
                        "label": "Activar Notificacion por Correo Electronico",
                        "checkedValue": "1",
                        "unCheckedValue": "0"
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "custom:wa_notification",
                        "label": "Activar Notificacion por Whatsapp",
                        "checkedValue": "1",
                        "unCheckedValue": "0"
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "custom:tel_notification",
                        "label": "Activar Notificacion por mensaje de texto",
                        "checkedValue": "1",
                        "unCheckedValue": "0"
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "custom:marketing",
                        "label": "Activar envio de promociones para los canales de notificacion activos",
                        "checkedValue": "1",
                        "unCheckedValue": "0"
                    },
                ],

            ]
        }
    ]
};

export default form;